import { useEffect, useMemo, useState } from 'react';
import { useDebounce } from 'use-debounce';
import doesRowMatchSearchString from '../Utils/doesRowMatchSearchString';
import doesRowMatchCategoryString from '../Utils/doesRowMatchCategoryString';
import doesRowMatchStatusString, { doesRowMatchStatusArray } from '../Utils/doesRowMatchStatusString';

/**
 * @param {object[]} rows The table rows.
 * @returns {Array} The memorized version of filtered rows, search string and the setter for the search string.
 */
const useFilteredRows = (originalData, rows, setQuoteItems, category, status) => {
	const [searchString, setSearchString] = useState('');
	const [categoryString, setCategoryString] = useState('');
	const [statusString, setStatusString] = useState('');
	const [statusArray, setStatusArray] = useState([]);
	const [debouncedSearchString] = useDebounce(searchString, 500);

	useEffect(() => {
		console.log('==================');
		console.log('statusArray', statusArray);
		console.log('==================');
	}, [statusArray, categoryString, debouncedSearchString]);

	const filteredRows = useMemo(() => {
		console.log('fSEARCH', searchString);
		console.log('fCAT', categoryString); //DEBUG
		console.log('fSTATUSARRAY', statusArray);
		if (!debouncedSearchString && categoryString === '' && statusArray.length === 0) {
			let newData = originalData;

			rows.map((row, i) => {
				if (row.selected) {
					newData[i].selected = true;
				} else {
					newData[i].selected = false;
				}

				if (row.expanded) {
					newData[i].expanded = true;
				} else {
					newData[i].expanded = false;
				}

				if (row.hide) {
					newData[i].hide = false;
				}
			});

			return newData;
		} else {
			return rows.map((row) => {
				if (
					doesRowMatchSearchString(row, debouncedSearchString) &&
					doesRowMatchCategoryString(row, categoryString) &&
					// doesRowMatchStatusString(row, statusString)
					doesRowMatchStatusArray(row, statusArray)
				) {
					row.hide = false;
				} else {
					row.hide = true;
				}
				return row;
			});
		}
	}, [debouncedSearchString, categoryString, rows, statusArray]);
	return [filteredRows, searchString, setSearchString, categoryString, setCategoryString, statusString, setStatusString, setStatusArray, statusArray];
};

export default useFilteredRows;
